import React from 'react';
import proptypes from 'prop-types';
const { string: stringType } = proptypes;
import { Typography } from '@one-thd/sui-atomic-components';

export function RecentPurchasesTableOrigin({ orderOrigin = null }) {
  const origin = orderOrigin || '';

  return (
    <div
      data-testid="orderOrigin"
      className="sui-flex sui-items-center sui-break-words sui-overflow-hidden sui-h-20"
    >
      <Typography lineClamp="2" variant="body-base">
        {origin}
      </Typography>
    </div>
  );
}

export function RecentPurchasesCardOrigin({ orderOrigin = null }) {
  const origin = orderOrigin || '';

  return (
    <div data-testid="orderOrigin" className="sui-flex sui-items-center">
      <span className="sui-mr-2">
        <Typography variant="body-base" weight="bold">
          Order Origin
        </Typography>
      </span>
      <span>
        <Typography variant="body-base">{origin}</Typography>
      </span>
    </div>
  );
}

RecentPurchasesTableOrigin.propTypes = {
  orderOrigin: stringType,
};

RecentPurchasesCardOrigin.propTypes = {
  orderOrigin: stringType,
};
